import { ArgsType, Field } from '@nestjs/graphql'

@ArgsType()
export class ReactivateUserEmailArgs {
  @Field()
  emailAddress?: string
}
